import React from "react";
import { useForm } from "react-hook-form";
import { FormInput, FormSelect } from "../../inputs";

const CopyLink = ({ next }) => {
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      link: "zenus.com/pay/h8dw76b9s8bfcbdj",
    },
  });
  const onSubmit = () => {
    next();
  };
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="contact-details">
          <h4>You’ve emailed a payment request to Santosh Pavan</h4>
          <p>
            to Santosh Pavan
            <span className="helper-text" style={{ marginTop: 0 }}>
              (santoshpavan@zenus.com)
            </span>
          </p>
        </div>
        <div className="form-body">
          <div className="pp-form-item">
            <FormSelect
              inline
              {...register("send_to")}
              label={"Deposit to"}
              control={control}
              options={[]}
              hideCreateOption={true}
              placeholder={"Select"}
              errors={errors}
            />
          </div>
          <div className="pp-form-item">
            <FormInput
              control={control}
              prefix={"$"}
              label={"Amount"}
              {...register("amount")}
              placeholder={"Enter Amount"}
              errors={errors}
              number={true}
            />
          </div>

          <div className="pp-form-item">
            <FormInput
              control={control}
              label={"Copy Link"}
              {...register("link", {
                value: "zenus.com/pay/h8dw76b9s8bfcbdj",
              })}
              placeholder={"Copy link"}
              errors={errors}
              suffix={<span className="link">Copy</span>}
            />
            <p className="helper-text">Expires on September 25, 2025</p>
          </div>
        </div>
        <div className="action-btns">
          <button type="button" className="back-btn">Create Another Request</button>
          <button className="send-btn">View All Payment Requests</button>
        </div>
      </form>
    </div>
  );
};

export default CopyLink;
